import * as React from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '../../../../../types/product.js';
import { getProductTealiumDescription } from '../../../../../utils/get-product-tealium-description.js';
import '../../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/lib-visuals';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '../../../../../slots/context.js';
import { FindAStoreCTA } from '../../../components/CTAs/FindAStoreCTA/FindAStoreCTA.js';
import { useGetPriceSegment } from '../../../hooks/use-get-price-segment.js';
import '@grandvisionhq/content';
import '@grandvisionhq/lib-utils-html';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';
import { SolutionsCTACaption } from './components/SolutionsCTACaption.js';
import { mapSolutionToDraftLineItem } from './map-solution-to-draft-line-item.js';

const SolutionsCTA = ()=>{
    const { getLabel  } = useIntl();
    const { routes , activeVariant , product , selectedPurchaseType  } = useProductData();
    const { priceSegment  } = useGetPriceSegment();
    const { state , actions , selectors  } = useSolutionsEcommContext();
    const isConfiguratorValid = selectors.isConfiguratorValid(state);
    const lineItemDraft = mapSolutionToDraftLineItem({
        sku: activeVariant.sku,
        state,
        purchaseType: selectedPurchaseType,
        priceSegment
    });
    if (activeVariant.channelAvailability !== 'ONLINE') {
        return /*#__PURE__*/ React.createElement(FindAStoreCTA, {
            href: routes.stores
        });
    }
    if (!isConfiguratorValid || !lineItemDraft) {
        // Dummy button with the "Add to cart" caption which only triggers form validations
        return /*#__PURE__*/ React.createElement(Button, {
            caption: getLabel('products.solutions.addToBasket'),
            onClick: actions.triggerValidationErrors
        });
    }
    return /*#__PURE__*/ React.createElement(AddToCart, {
        caption: /*#__PURE__*/ React.createElement(SolutionsCTACaption, null),
        lineItemDrafts: [
            lineItemDraft
        ],
        "data-element-id": "Prod_AddCart",
        "data-description": getProductTealiumDescription(product.name, activeVariant.sku)
    });
};

export { SolutionsCTA };
//# sourceMappingURL=SolutionsCTA.js.map
